// extracted by mini-css-extract-plugin
module.exports = {"root":"QueueSort-root-ddab32569348ca1580840dd7f9eb443e"};